var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("inline-form", {
    staticClass: "form vue-ready__hide",
    attrs: { action: _vm.action },
    on: { success: _vm.onSuccess },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function(props) {
          return _c(
            "div",
            {},
            [
              _vm._t(
                "default",
                null,
                { success: _vm.formSubmissionSuccess },
                props
              )
            ],
            2
          )
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-89e41b8a", { render: render, staticRenderFns: staticRenderFns })
  }
}